import * as Yup from "yup";
import dayjs from "dayjs";

const integerValidation = (value) => {
    if (!Number.isInteger(value) || String(value).includes('.')) {
        return false;
    }
    return true;
}

export const validateRowTransformIntoSchema = Yup.object().shape({
    itemId: Yup
        .string()
        .required(),
    uomId: Yup
        .string()
        .required(),
    isDefaultUom: Yup
        .boolean()
        .required(),
    qty: Yup.lazy((val) => {

        let maxQty = val?.maxQty ? val.maxQty : 0

        let valueSchema;

        valueSchema = Yup
            .number("")
            .typeError("Invalid")
            // .min(parseFloat(minQty))
            .max(parseFloat(maxQty), `Max : ${maxQty}`)
            .positive("More than 0")
            .required("Required")

        return Yup.object().shape({
            value: valueSchema,
            maxQty: Yup.mixed().nullable().typeError("Invalid"),
        })


    })
})

export const validateRowInventorySchema = Yup.object().shape({
    batchId: Yup
        .string(),
    slotId: Yup
        .string()
        .required(),
    qty: Yup.lazy((val) => {

        let maxQty = val?.maxQty ? val.maxQty : 0

        let valueSchema;

        valueSchema = Yup
            .number("")
            .typeError("Invalid")
            // .min(parseFloat(minQty))
            .max(parseFloat(maxQty), `Max : ${maxQty}`)
            .positive("More than 0")
            .required("Required")

        return Yup.object().shape({
            value: valueSchema,
            maxQty: Yup.mixed().nullable().typeError("Invalid"),
        })


    })
})

export const validateRowSchema = Yup.object().shape({
    itemId: Yup
        .string()
        .required("Required"),
    name: Yup
        .string()
        .required("Required"),
    description: Yup
        .string()
        .required("Required"),
    uomId: Yup
        .string()
        .required("Required"),
    defaultUomItemId: Yup
        .string()
        .required("Required"),
    productId: Yup
        .string()
        .required("Required"),
    transformToUomId: Yup
        .string()
        .required("Required"),
    transformToFinalQty: Yup
        .number("").test('integer', 'Must round value', (value) => integerValidation(value))
        .typeError("Invalid")
        .min(1, `Min (1)`)
        // .max(parseFloat(maxQty), `Max : ${maxQty}`)
        .positive("More than 0")
        .required("Required"),
    transformToRackId: Yup
        .string()
        .required("Required"),
    transformToSlotId: Yup
        .string()
        .required("Required"),
    price: Yup
        .number("")
        .positive("Invalid")
        .required("Required"),
    // inventory: Yup.array().of(validateRowInventorySchema),
    // transformInto: Yup.array().of(validateRowTransformIntoSchema),
})


export const validationSchema = Yup.object({
    locationId: Yup
        .string()
        .required("Required"),
    documentDate: Yup
        // .string()
        .date("Invalid")
        .required("Required")
        .typeError("Invalid"),
    rows: Yup.array().of(validateRowSchema)
})

export const initialRowTransformIntoValues = {
    itemId: "",
    uomId: "",
    uomName: "",
    transformRatio: "",
    isDefaultUom: false,
    qty: {
        value: "",
        // maxQty: 0,
    },
}

export const initialRowInventoryValues = {
    batchId: "",
    label: "",
    slotId: "",
    customBatchNo: "",
    expiryDate: "",
}

export const initialRowValues = {
    productId: "",
    itemId: "",
    name: "",
    code: "",
    description: "",
    transformToItemId: "",
    transformToUomId: "",
    transformToUomName: "",
    transformToFinalQty: 0,
    transformToFinalCalculatedQty: 0,
    transformForceMode: 0,

    transformToRackId: "",
    transformToSlotId: "",
    transformToBatchNo: "",
    transformToExpiryData: dayjs(),
    uomName: "",
    uomId: "",
    defaultUomItemId: "",

    inventory: [],
    inventoryTotalQty: 0,
    transformInto: [],
}

export const initialValues = {
    locationId: "",
    locationName: "",
    documentDate: dayjs(),
    remark: "",
    rows: [initialRowValues],
}